import React, { useEffect } from "react";
import { Table, Button } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import { useTranslation } from "react-i18next";

export default observer(function EmailLogPage() {
  const { emailLogStore } = useStore();
  const { t } = useTranslation();

  useEffect(() => {
    emailLogStore.fetchLogs();
  }, [emailLogStore]);

  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{t("emails.logs.recipients")}</Table.HeaderCell>
          <Table.HeaderCell>{t("emails.logs.subject")}</Table.HeaderCell>
          <Table.HeaderCell>{t("emails.logs.sentAt")}</Table.HeaderCell>
          <Table.HeaderCell>{t("emails.logs.status")}</Table.HeaderCell>
          <Table.HeaderCell>{t("emails.logs.actions")}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {emailLogStore.logs.map(log => (
          <Table.Row key={log.id}>
            <Table.Cell>
              {/* Recipients is a string (comma-separated) in the backend, so display as is */}
              {Array.isArray(log.recipients)
                ? log.recipients.join(", ")
                : log.recipients}
            </Table.Cell>
            <Table.Cell>{log.subject}</Table.Cell>
            <Table.Cell>{log.sentAt}</Table.Cell>
            <Table.Cell>{log.status}</Table.Cell>
            <Table.Cell>
              <Button onClick={() => emailLogStore.downloadLogPdf(log.id)}>
                {t("emails.logs.downloadPdf")}
              </Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
});
